// import Api from '@/api'

export default {
    namespaced: true,
    state: {
        route: 'generate'
    },
    actions: {
        push ({commit}, routeKey) {
            commit('route', routeKey)
        },
        reset ({commit}) {
            commit('route', 'generate')
        }
    },
    mutations: {
        route (state, routeKey) {
            state.route = routeKey
        }
    }
}
